/**
 * Proccess html string markups
 */
export default class HtmlString {
    /**
     * Removes given html tag from a message.
     * The given tagType are removed and a tag type label is added at the end of the tag if addTagTypeLabel is set.
     * @param {String} msg - A string message which can contain A tags.
     * @param {String} tagType - An html tag type (ex: b, a, div, span)
     * @param {String} addTagTypeLabel - a type label text to add at the end of the replaced tag (for aria description)
     * @returns {string}
     */
    removeGivenTag(msg, tagType, addTagTypeLabel) {
        const regTagEnd = new RegExp(`<\/${tagType}>`, "g");

        if (regTagEnd.test(msg)) {
            /*
             * Removes all <a> tags from the message but add A tag type (link)
             * to prevent unexpected screen reader behavior
             */
            msg = replaceAll(msg, regTagEnd, addTagTypeLabel ? (` ${addTagTypeLabel}`) : "");
            const regTagStart = new RegExp(`<${tagType}[^>]*>`, "g");
            msg = replaceAll(msg, regTagStart, "");
        }

        return msg;

        function replaceAll(str, a, b) {
            return str.split(a).join(b);
        }
    }

    /**
     * removeIdAttributes - is used to remove "id" attribute from
     * a message to prevent duplicate "id" attributes in the chat.
     *
     * @param {string} msg
     * @return {string}
     */
    removeIdAttributes(msg) {
        return msg.replace(/id=("|').+?("|')/gi, "");
    }

    /**
     * Removes all HTML elements with their attributes to avoid unexpected
     * behavior during pronouncement of new messages in the live aria.
     *
     * Ex:
     * msg: "this is <br>a new test" becomes "this is a new test".
     * If not removed reader could read "this is 'less than br greater than' a new test".
     *
     * @param {string} msg
     * @return {string}
     */
    removeHTMLMarkup(msg) {
        return msg.replace(/(?: )?<.*?>(?: )?/gi, " ").trim();
    }

    /**
     * isEmptyString - is used to check passed param by type and its length ignoring left and right spaces.
     *
     * @param {*} str
     * @return {boolean}
     */
    isEmptyString(str) {
        return typeof (str) !== "string" || str.trim().length === 0;
    }

    /**
     * generateRandomString - is used to generate random string value of specied length from
     * passinge character set or from alhpanumric values eg aA-AZ-0-9
     * @param {number} len
     * @param {string} charSet
     * @return {string}
     */
    generateRandomString(len, charSet) {
        charSet = charSet || "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let randomString = "";

        for (let i = 0; i < len; i++) {
            const randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz, randomPoz + 1);
        }
        return randomString;
    }
}
